import React, { Suspense, useState } from "react";
import "../Registration/Registration.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
} from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { BsFacebook } from "react-icons/bs";
import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import {connect} from "react-redux";

function Register_renters_list(props) {
  const {frontLabelsName} = props.label;
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container mb-5 pt-5">
        <div className="row">
          <div className="main-login">
            <div className="login-box2 d-flex">
              <div className="col-md-6">
                <Form>
                  <div className="text-center">
                    <h2 className="set-font-size">
                    {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_register_renter_list"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_register_renter_list"
                                )[0]["value"] || "lbl_register_renter_list"
                              : "lbl_register_renter_list"
                            : "lbl_register_renter_list"}
                    </h2>
                  </div>
                  <div className="set-pdd">
                    <FormGroup className="set-bg-feild">
                      <Input type="text" name="userName" placeholder=
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_name"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_name"
                            )[0]["value"] || "lbl_name"
                          : "lbl_name"
                        : "lbl_name"} />
                    </FormGroup>
                    <FormGroup className="set-bg-feild">
                      <Input type="Email" name="Email" placeholder=
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_email"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_email"
                            )[0]["value"] || "lbl_email"
                          : "lbl_email"
                        : "lbl_email"} />
                    </FormGroup>
                    <FormGroup className="set-bg-feild">
                      <Input
                        type="password"
                        name="Password"
                        placeholder={frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_password"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_password"
                              )[0]["value"] || "lbl_password"
                            : "lbl_password"
                          : "lbl_password"}
                      />
                    </FormGroup>
                    <FormGroup className="set-bg-feild">
                      <Input
                        type="password"
                        name="Confirm_password"
                        placeholder={frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_confirm_password"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_confirm_password"
                              )[0]["value"] || "lbl_confirm_password"
                            : "lbl_confirm_password"
                          : "lbl_confirm_password"}
                      />
                    </FormGroup>

                    <div className="button-set">
                      <Button>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_register"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_register"
                            )[0]["value"] || "lbl_register"
                          : "lbl_register"
                        : "lbl_register"}
                      </Button>
                    </div>
                    <div className="main-bottom-button d-flex">
                      <Button>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_login_electronic_id"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_login_electronic_id"
                            )[0]["value"] || "lbl_login_electronic_id"
                          : "lbl_login_electronic_id"
                        : "lbl_login_electronic_id"}
                      </Button>
                      <Button className="custom-color-set">
                        <span>
                          <BsFacebook className="set-space" />
                        </span>
                        
                        {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_login_with_facebook"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_login_with_facebook"
                            )[0]["value"] || "lbl_login_with_facebook"
                          : "lbl_login_with_facebook"
                        : "lbl_login_with_facebook"}
                      </Button>
                    </div>
                    <div className="bottom-links text-center">
                      <span>
                       
                        {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_already_access"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_already_access"
                            )[0]["value"] || "lbl_already_access"
                          : "lbl_already_access"
                        : "lbl_already_access"}
                        <Link to="/login" className="set-yellow" style={{marginLeft:2}}>
                          
                          {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_check_in"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_check_in"
                            )[0]["value"] || "lbl_check_in"
                          : "lbl_check_in"
                        : "lbl_check_in"}
                        </Link>
                      </span>
                    </div>
                  </div>
                </Form>
              </div>
              <div className="horizonal-row"></div>
              <div className="col-md-6">
                <div className="set-hr-color">
                  <div className="icon-box-img">
                    <img src="assets/run.svg" alt="run" />
                    <div className="desc-icon">
                      <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_you_are_one_step"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_you_are_one_step"
                            )[0]["value"] || "lbl_you_are_one_step"
                          : "lbl_you_are_one_step"
                        : "lbl_you_are_one_step"}
                      </h2>
                    </div>
                  </div>
                  <div className="icon-box-img">
                    <img src="assets/searchuser.svg" alt="run" />
                    <div className="desc-icon">
                      <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_free_registration_landlord"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_free_registration_landlord"
                            )[0]["value"] || "lbl_free_registration_landlord"
                          : "lbl_free_registration_landlord"
                        : "lbl_free_registration_landlord"}
                      </h2>
                    </div>
                  </div>
                  <div className="icon-box-img">
                    <img src="assets/shield.svg" alt="run" />
                    <div className="desc-icon">
                      <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_safer_rntal"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_safer_rntal"
                            )[0]["value"] || "lbl_safer_rntal"
                          : "lbl_safer_rntal"
                        : "lbl_safer_rntal"}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}

const mapStateToProps =(state) => ({
  label:state.language
})
export default connect(mapStateToProps,{})(Register_renters_list);
